import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>© {new Date().getFullYear()} River Rats Marketing Timeline</p>
      <p>
        A case study on what worked and what didn't in marketing a card game
      </p>
    </footer>
  );
};

export default Footer;
